export default __webpack_public_path__ + "static/media/AppStoreIcon.ea068157.svg";